import { create } from "zustand";
type ThemeMode = "light" | "dark";
type Language = "en" | "zh-CN";

interface Config {
  theme: ThemeMode;
  setTheme: (theme: ThemeMode) => void;
  locale: Language;
  setLanguage: (locale: Language) => void;
}

export const useConfigStore = create<Config>((set) => ({
  theme: (() => {
    if (typeof localStorage === "undefined") return "dark";
    return localStorage.getItem("theme") === "light" ? "light" : "dark";
  })(),
  setTheme: (theme: ThemeMode) =>
    set(() => {
      if (typeof localStorage !== "undefined") {
        localStorage.setItem("theme", theme);
        if (theme === "dark") {
          document.documentElement.classList.add("dark");
        } else {
          document.documentElement.classList.remove("dark");
        }
      }
      return { theme };
    }),
  locale: (() => {
    if (typeof localStorage === "undefined") return "zh-CN";
    const lang = localStorage.getItem("lang");
    return lang === "en" ? "en" : "zh-CN";
  })(),
  setLanguage: (locale: Language) =>
    set(() => {
      if (typeof localStorage !== "undefined") {
        localStorage.setItem("lang", locale);
      }
      return { locale };
    }),
}));
